if (!customElements.get('mbh-home-carousel')) {
  customElements.define('mbh-home-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.toggle = this.querySelector('[data-toggle]');
      this.status = this.querySelector('[data-status]');
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.motion.matches || Boolean(window.Shopify?.designMode);
      this.visible = false;
      this.hovered = false;
      this.focused = false;
      this.interval = Math.max(3000, Math.min(10000, Number(this.dataset.interval) || 4000));
      const on = (target, type, fn) => target.addEventListener(type, fn, { signal: this.abort.signal });
      on(this.querySelector('[data-prev]'), 'click', () => this.manual(this.index - 1));
      on(this.querySelector('[data-next]'), 'click', () => this.manual(this.index + 1));
      this.dots.forEach((dot,i) => on(dot, 'click', () => this.manual(i)));
      on(this.toggle, 'click', () => {
        this.paused = !this.paused;
        if (!this.paused) { this.focused = false; this.hovered = false; }
        this.updateButton();
        this.schedule();
      });
      on(this,'pointerenter',event=>{if(event.pointerType==='mouse'){this.hovered=true;this.schedule();}});
      on(this,'pointerleave',()=>{this.hovered=false;this.schedule();});
      on(this,'focusin',()=>{this.focused=true;this.schedule();});
      on(this,'focusout',event=>{this.focused=this.contains(event.relatedTarget);this.schedule();});
      on(document,'visibilitychange',()=>this.schedule());
      on(this.motion,'change',()=>{if(this.motion.matches)this.paused=true;this.updateButton();this.schedule();});
      on(document,'shopify:block:select',event=>{
        const i=this.slides.findIndex(slide=>slide.dataset.blockId===event.detail?.blockId);
        if(i>=0)this.manual(i);
      });
      this.observer=new IntersectionObserver(entries=>{
        this.visible=entries.some(entry=>entry.isIntersecting);this.schedule();
      },{threshold:0.1});
      this.observer.observe(this);
      this.querySelector('[data-controls]').hidden=false;
      this.updateButton();
      this.show(this.index,false);
    }
    manual(index) {
      this.paused=true;
      this.updateButton();
      this.show(index,true);
      this.schedule();
    }
    show(index,announce) {
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{
        const active=i===this.index;
        slide.classList.toggle('is-active',active);
        slide.setAttribute('aria-hidden',String(!active));
        this.dots[i]?.setAttribute('aria-pressed',String(active));
      });
      const image=this.slides[this.index].querySelector('img');
      if(image)image.loading='eager';
      if(announce&&this.status)this.status.textContent=this.slides[this.index].getAttribute('aria-label');
    }
    updateButton() {
      this.toggle.setAttribute('aria-label',this.paused?this.dataset.playLabel:this.dataset.pauseLabel);
      this.toggle.querySelector('[data-play-icon]').textContent=this.paused?'▶':'Ⅱ';
    }
    schedule() {
      clearTimeout(this.timer);
      if(this.paused||!this.visible||this.hovered||this.focused||document.hidden)return;
      this.timer=setTimeout(()=>{this.show(this.index+1,false);this.schedule();},this.interval);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort=null;
    }
  });
}
